// extracted by mini-css-extract-plugin
export default {"info":"role-description-popover_info__vYd04"};